<script lang="ts">
  import SelectedBookmarkIcon from '$lib/assets/icons/SelectedBookmarkIcon.svelte';
  import BookmarkIcon from '$lib/assets/icons/BookmarkIcon.svelte';

  export let isBookmarked = false;
  export let handleAddBookMark = () => null;
</script>

<button class="bookmark-wrapper" on:click|stopPropagation|preventDefault={handleAddBookMark}>
  {#if isBookmarked}
    <SelectedBookmarkIcon />
  {:else}
    <BookmarkIcon />
  {/if}
</button>

<style lang="scss">
  .bookmark-wrapper {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(20, 25, 35, 0.4);
    border: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
</style>
